import React from "react";
import { motion } from "framer-motion";
import shapeThree from "../../../Assets/Images/Shape 3.png";
import shapeFour from "../../../Assets/Images/Shape 4.png";
import "./WepAppBanner.css";
import { BannerMarquee } from "../../ServicePage/WebDevelopment/BannerMarquee/BannerMarquee";
import { Link } from "react-router-dom";

const WepAppBanner = () => {
  return (
    <section
      className="web-app-content"
      style={{
        overflowX: "hidden",
      }}
    >
      <div className="d-flex flex-column justify-content-center align-items-center text-center  ">
        {/* background shapes */}
        <div style={{ zIndex: "0" }}>
          <img className="shape-three " src={shapeThree} alt="" />
          <img className="shape-four" src={shapeFour} alt="" />
        </div>

        {/* main content */}
        <div
          className="position-relative d-flex flex-column justify-content-center align-items-center py-4"
          style={{
            maxWidth: "816px",
            textAlign: "center",
            zIndex: "4",
            margin: "0 0",
          }}
        >
          <h2 className="fw-semibold web-app-heading text-dark mb-3 ">
            Web Development Built Beyond The Launch
          </h2>

          <p className="text-secondary px-4 web-app-text small mb-2">
            Most websites feel like they are done the day they go live. Problems
            show up later. Traffic spikes, content changes, integration breaks,
            and small decisions begin to slow it all down. At Quad Theory Ltd,
            web development is focused on what comes after launch.
          </p>

          <p className="text-secondary px-4 web-app-text small mb-4">
            We create web platforms that remain fast under real traffic
            conditions, continue to be flexible as requirements evolve, and are
            easy for teams to manage without ongoing support from developers.
            The idea is a website that will continue to function as your
            business evolves.
          </p>

          <Link to="/contact-us">
            <motion.button
              type="button"
              className="btn  px-5 py-3 rounded-pill"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",
                // scale: 1.05,
                boxShadow: "none",
              }}
              transition={{ duration: 0.2 }}
              style={{
                border: "none",
                color: "#fff",
                fontWeight: "500",
                zIndex: 5,
                fontSize: "2rem",
              }}
            >
               Build Your Website
            </motion.button>
          </Link>
        </div>
      </div>

      <BannerMarquee></BannerMarquee>
    </section>
  );
};

export default WepAppBanner;
